import { BaseAddress } from "../../config";
import performRequest from "../../utils/requestHelpers";
import { getMeta, getDashboard } from "./mockServer";

const USE_MOCK = false;

// Здоровье живёт под префиксом CcAdmin (/api/scadmin), а не Api (/api/kulsary)
const BASE = BaseAddress.CcAdmin;

const withAuth = (option) => {
  const token = localStorage.getItem("token");
  return token
    ? {
        ...option,
        headers: {
          ...(option && option.headers),
          Authorization: "Bearer " + token,
        },
      }
    : option;
};

const delay = (data, ms = 300) =>
  new Promise((resolve) => setTimeout(() => resolve(data), ms));

// снимает конверт { data: ... } / { result: ... }, если бэк заворачивает; иначе identity
const unwrap = (raw) =>
  raw && typeof raw === "object" && !raw.summary && !raw.periods
    ? raw.data ?? raw.result ?? raw
    : raw;

const normalizeMeta = (raw) => {
  const d = unwrap(raw);
  return {
    default_type: d.default_type ?? "year",
    periods: {
      year: d.periods?.year ?? [],
      quarter: d.periods?.quarter ?? [],
    },
  };
};

const normalizeDashboard = (raw) => {
  const d = unwrap(raw);
  return {
    summary: d.summary ?? {
      total: 0,
      good: 0,
      bad: 0,
      no_data: 0,
      completion_pct: 0,
    },
    items: d.items ?? [],
  };
};

export const fetchMeta = () => {
  if (USE_MOCK) return delay(getMeta(), 150);
  return performRequest(`${BASE}/api/health/meta`, withAuth()).then(
    normalizeMeta,
  );
};

export const fetchDashboard = ({ type, report, from, to }) => {
  if (USE_MOCK) return delay(getDashboard({ type, report, from, to }));
  const qs = `type=${type}&report=${encodeURIComponent(
    report,
  )}&from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`;
  return performRequest(`${BASE}/api/health/dashboard?${qs}`, withAuth()).then(
    normalizeDashboard,
  );
};
